import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttDialog, SttList } from '../../../sporttia/all';

export type BusyError = {
    weekday: number;
    message: string;
};

type Props = {
    errors: BusyError[] | null;
    onClose: () => void;
};

export default function ErrorsDialog({
    errors,
    onClose,
}: Props): React.ReactElement | null {
    const { t } = useTranslation();

    if (!errors) {
        return null;
    }

    return (
        <SttDialog
            onClose={onClose}
            open
            buttons={[
                {
                    type: 'close',
                    onClick: onClose,
                },
            ]}
            title={t('Errors')}
            content={
                <Box p={2}>
                    <Box mb={2}>
                        <Typography variant="body1">
                            {t('busySchedules.errorsTitle')}
                        </Typography>
                    </Box>
                    <Box>
                        <SttList
                            data={errors.map((error: BusyError, i: number) => ({
                                caption: `${i + 1}. ${t(`day.${error.weekday}.name`)}`,
                                text: t(error.message),
                            }))}
                        />
                    </Box>
                </Box>
            }
        />
    );
}
